<template>
  <b-card class="exam-card-item transition" no-body style="padding: 15px; border-radius: 10px; transition: transform 0.3s, box-shadow 0.3s;" 
          @mouseover="hover = true" @mouseleave="hover = false" 
          :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)', boxShadow: hover ? '0 4px 20px rgba(0, 0, 0, 0.1)' : '0 2px 8px rgba(0, 0, 0, 0.05)' }">
    <!-- Header Section -->
    <b-row align-h="between" class="mb-3">
      <b-col>
        <h5 class="text-primary mb-1">
          {{ item.title }}
        </h5>
        <p class="text-muted small mb-0">
          {{ item.description || 'No description available' }}
        </p>
      </b-col>
      <b-col cols="auto" class="text-right">
        <b-badge v-if="access_type === 'candidate'" :variant="getExamStatusVariant(item)" class="font-weight-bold px-3 py-2">
          {{ item.application_exam.score || 0 }} / {{  item.total_points || 0 }} Points
        </b-badge>
        <b-badge v-else :variant="getExamStatusVariant(item)" class="font-weight-bold px-3 py-2">
          {{ item.total_points || 0 }} Points
        </b-badge>
      </b-col>
      <b-col cols="auto" class="text-right">
        <b-badge :variant="getExamStatusVariant(item)" class="font-weight-bold px-3 py-2">
          {{ item.applicant_count }} Applicants
        </b-badge>
      </b-col>
    </b-row>

    <!-- Schedule and Details -->
    <b-row class="mb-3">
      <b-col cols="auto" class="text-right">
        <span class="text-dark font-weight-bold">
          Duration: {{ item.duration || 'N/A' }}
        </span>
      </b-col>
    </b-row>

    <!-- Actions -->
    <b-row align-h="between">
      <b-col>
        <b-button size="sm" variant="primary" @click="viewEssayGradingDetails(item.exam_id)">
          View Answers
        </b-button>
      </b-col>
    </b-row>

    <EssayGradingModal :examId="selectedItem" ref="gradingModal" />
  </b-card>
</template>


<script>
import EssayGradingModal from './EssayGradingModal.vue';
export default {
  components: {
    EssayGradingModal,
  },
  props: {
    item: Object,
    access_type: String,
  },
  computed: {
    formattedSalary() {
      return (item) => {
        const minSalary = (item.min_salary ? item.min_salary.$numberDecimal : 0) || 0;
        const maxSalary = (item.max_salary ? item.max_salary.$numberDecimal : 0) || 0;
        return `${minSalary | item.currency_id.symbol} - ${maxSalary | item.currency_id.symbol}`;
      };
    },
  },
  data() {
    return {
      hover: false,
      selectedExam: null,
      selectedItem: null,
    }
  },
  methods: {
    getExamStatusVariant(item) {
      return item.status === "Not Started"
      ? "primary"
      : item.status === "In Progress"
      ? "warning"
      : item.status === "Completed"
      ? "success"
      : item.status === "Essay Grading in Progress"
      ? "danger"
      : "secondary";
    },
    formattedSchedule(item) {
      if (item.schedule_start && item.schedule_end) {
        return `${item.schedule_start} - ${item.schedule_end}`;
      }
      return "Not Scheduled";
    },
    viewExamDetails(item) {
      console.log(item);
    },
    viewEssayGradingDetails(item) {
      this.selectedItem = item;
      this.$refs.gradingModal.$refs.gradingModal.show();
    },
    showCompanyButton() {
      return !this.companyID && this.hasRole('company.view');
    },
    showGenerateUrl() {
      return this.hasRole('job.generate_url');
    },
    canGenerateUrl(item) {
      return !item.job_url && this.hasRole('job.generate_url') && !this.companyID;
    },
    canCopyUrl(item) {
      return item.job_url && this.hasRole('job.generate_url') && this.companyID;
    },
    canGenerateCompanyUrl(item) {
      return !item.job_company_url && this.hasRole('job.generate_url');
    },
    generateUrlText() {
      return !this.companyID ? 'Generate Company URL' : 'Generate URL';
    },
    canSubmitCandidate(item) {
      return item.active && (item.slots - item.hired) > 0 && this.hasRole('job.submit_candidate');
    },
    canActivateDeactivate() {
      return this.user.role.role == 'administration' && this.hasRole('job.activate');
    },
    canPost() {
      return this.hasRole('job.post');
    },
    canEdit(item) {
      return this.user.role.role == 'administration' && !item.published;
    },
    canViewJob() {
      return this.hasRole('job.view');
    },
    hasRole(value) {
      return this.role_modules.some(role => role.value === value);
    },
    isDraft(item) {
      return !item.published && !item.posted;
    },
    isUnposted(item) {
      return !item.published && item.posted;
    },
    showDropdownButton(item) {
      return item.hasDropdownBtn;
    },
    getQuestionCount(item) {
      return item.essay_questions ? item.essay_questions.length : 0;
    },
  }
};
</script>